import * as $ from "jquery";
import * as Modernizr from "../../lib/modernizr-3.5.0.min.js";
import * as enquire from 'enquire.js';

namespace PFF.controllers.thermoforce {

	//this if for the restore showerhead innovation page
	function initVerticalSlider(){
		var $range = $('.js-vertical-input');
		var $showerheadImgContainer = $('.js-img-rotation');
		var $featureImg = $('.js-headfeature-img');
		var eventType = Modernizr.ie11 ? "change" : "input";
		let $contentTitle = $('.js-content-title');
		let $content = $('.js-content');

		$featureImg.each(function(index){
			$(this).addClass('js-headfeature-img--'+(index+1));
		});


		$range.on(eventType, function(){
			let theValue = this.value;
			$showerheadImgContainer.removeClass(function (index, classNames) {
				var current_classes = classNames.split(" "), // change the list into an array
					classes_to_remove = []; // array of classes which are to be removed

				$.each(current_classes, function (index, class_name) {
					// if the classname begins with bg add it to the classes_to_remove array
					if (/v-innovations__head-rotator-rotation--.*/.test(class_name)) {
						classes_to_remove.push(class_name);
					}
				});
				// turn the array back into a string
				return classes_to_remove.join(" ");
			});

			switch(this.value) {
				case "1":
					$showerheadImgContainer.addClass('v-innovations__head-rotator-rotation--setting-1');
					break;
				case "2":
					$showerheadImgContainer.addClass('v-innovations__head-rotator-rotation--setting-2');
					break;
				case "3":
					$showerheadImgContainer.addClass('v-innovations__head-rotator-rotation--setting-3');
					break;
				case "4":
					$showerheadImgContainer.addClass('v-innovations__head-rotator-rotation--setting-4');
					break;
				case "5":
					$showerheadImgContainer.addClass('v-innovations__head-rotator-rotation--setting-5');
					break;
				case "6":
					$showerheadImgContainer.addClass('v-innovations__head-rotator-rotation--setting-6');
					break;
				default:
					$showerheadImgContainer.addClass('v-innovations__head-rotator-rotation--setting-1');
			}

			$featureImg.removeClass('state-visible');
			$contentTitle.removeClass('state-visible');
			$content.removeClass('state-visible');
			$('#content-title-'+this.value).addClass('state-visible');
			$('#content-'+this.value).addClass('state-visible');
			$('.js-headfeature-img--'+this.value).addClass('state-visible');
		});
	}

	function mobileMoveSlider(){
		let $headRotator = $('.js-head-rotator');
		let $visual = $('.js-visual');
		let $container  = $('.js-container');
		enquire.register("screen and (max-width:767px)", {
			match: function() {
				$visual.insertBefore($container);
			},
			unmatch: function() {
				$visual.appendTo($headRotator);
			},
		});
	}

	function addModernizrTest() {
		Modernizr.addTest('ie11', function () {
			function GetIEVersion() {
				let sAgent = window.navigator.userAgent;
				let Idx = sAgent.indexOf("MSIE");

				if (Idx > 0) {
					return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
				} else if (!!navigator.userAgent.match(/Trident\/7\./)) {
					return 11;
				} else {
					return 0;
				}
			}

			if (GetIEVersion() === 11) {
				return true;
			} else {
				return false;
			}
		});
	}


	export function init() {
		addModernizrTest();
		initVerticalSlider();
		mobileMoveSlider();
	}
}

PFF.controllers.thermoforce.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/thermoforce.ts